<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="result-table list-content nopads" style="width: 100%; scrollbar-width: none; -ms-overflow-style: none;">
        <vue3-datatable
                  ref="resultTable"
                  :rows="results"
                  :columns="fields"
                  :pagination="false"
                  :sticky-header="true"
                  height="77vh"
                  :sortable="true"
                  skin="bh-table-compact"
                  row-class="routa-table-row"
                  cell-class="routa-table-cell"
                  @row-click="emitShow"
              >
                  <template #empty>
                      <div class="text-center my-2">
                          {{ $t('area_report.no_results') }}
                      </div>
                  </template>
                  <template #time="row">
                      {{ toLocalTime(row.value.time) }}
                  </template>
                  <template #user="row">
                      {{ row.value.user.last_name }}, {{ row.value.user.first_name }}
                  </template>
                  <template #company="row">
                      {{ row.value.company.name }}
                  </template>
                  <template #contract="row">
                      {{ row.value.contract.name }} <span
                      v-if="row.value.contract.contract_number"
                  >({{ row.value.contract_number }})</span>
                  </template>
                  <template #type="row">
                      {{ getTypeString(row.value.type) }}
                  </template>
                  <template #location="row">
                <span v-if="row.value.x && row.value.y">{{
                        row.value.location.y.toFixed(6)
                    }} {{ row.value.location.x.toFixed(6) }}</span>
                  </template>
                  <template #state="row">
                      {{ getStateString(row.value) }}
                  </template>
                  <template #resolver="row">
                <span v-if="row.value.resolved_by">
                  {{ row.value.resolved_by.last_name }}, {{ row.value.resolved_by.first_name }}
                </span>
                  </template>
                  <template #resolved_time="row">
                        <span v-if="row.value.resolved_time">
                          {{ toLocalTime(row.value.resolved_time) }}
                        </span>
                  </template>
                  <template #note="row">
                      {{ row.value.resolved_notes }}
                  </template>
              </vue3-datatable>
  </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'UserAlertList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        },
        canAdd: Boolean
    },
    data() {
        return {
            sortBy: 'username',
            sortDesc: false,
            fields: [
                {field: 'time', title: this.$t('user_alert.time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'user', title: this.$t('user_alert.person'), sort: true, headerClass: 'routa-table-header'},
                {field: 'company', title: this.$t('user_alert.company'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract', title: this.$t('user_alert.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('user_alert.type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'location', title: this.$t('user_alert.location'), sort: true, headerClass: 'routa-table-header'},
                {field: 'state', title: this.$t('user_alert.state'), sort: true, headerClass: 'routa-table-header'},
                {field: 'resolver', title: this.$t('user_alert.resolver'), sort: true, headerClass: 'routa-table-header'},
                {field: 'resolved_time', title: this.$t('user_alert.resolve_date'), sort: true, headerClass: 'routa-table-header'},
                {field: 'note', title: this.$t('user_alert.notes'), sort: true, headerClass: 'routa-table-header'},
            ],
            loading: false
        }
    },
    methods: {
        emitShow: function (result) {
            let item = this.results.find(item => result.id === item.id)
            if (item) {
                this.$emit('show', item)
            }
        },
        getTypeString(type) {
            switch (type) {
                case 1:
                    return this.$t('user_alert.types.user_initiated')
                case 2:
                    return this.$t('user_alert.types.automatic')
            }
            return ''
        },
        getStateString(alert) {
            if (alert.resolved_time) {
                return this.$t('user_alert.states.resolved')
            }
            return this.$t('user_alert.states.open')
        }
    }
}
</script>
